module.exports = __webpack_public_path__ + "static/media/cityscape.d409ead0.png";